import AttachmentPrimaryContent from './AttachmentPrimaryContent';

export default AttachmentPrimaryContent;
